import { defineSlotRecipe } from '@chakra-ui/react'
import { toastAnatomy } from '@chakra-ui/react/anatomy'

const rootTransparentStyle = {
    backgroundColor: 'transparent',
    boxShadow: 'none',
}

export const toastSlotRecipe = defineSlotRecipe({
    slots: toastAnatomy.keys(),
    base: {
        root: {
            backgroundColor: 'transparent',
            padding: 0,
            '&[data-type]': rootTransparentStyle,
        },
        closeTrigger: {
            display: 'none',
        },
        actionTrigger: {
            display: 'none',
        },
        description: {
            display: 'none',
        },
        indicator: {
            display: 'none',
        },
        title: {
            display: 'none',
        },
    },
})
